export default __webpack_public_path__ + "static/herobg-3ac9ae76bf5c431aec1b81960eb9f400.png";